import * as React from 'react';
import styled from 'styled-components';

export const ScrollableTable = styled.div`
    overflow-x: auto;
`;
